import { connect } from "react-redux";
import ComparedTable from "./ComparedTable";
import { getProjectComparison } from "../../../../../../../../../../redux/actions";
import { selectTrendTotals } from "../../../../utils/selectTrendTotals";

// The list and paging only. The pairing (match mode, baseline picks) is read
// per row by ComparedRow, so a dropdown change doesn't re-render the table.
const mapStateToProps = (state) => ({
    benchmarkFiltersAnalysis: state.BenchmarkFilteringReducer.benchmarkFiltersAnalysis,
    fetchProjectComparisonApi: state.BenchmarkFilteringReducer.fetchProjectComparisonApi,
    // What the badge counts: this list's own size against everyone in scope.
    // Neither figure is the number of rows loaded, so scrolling the list doesn't
    // move them — see selectTrendTotals.
    listTotal: selectTrendTotals(state).comparedListTotal,
    totalCount: selectTrendTotals(state).totalCount,
});

const mapDispatchToProps = (dispatch) => ({
    getProjectComparison: (payload) => dispatch(getProjectComparison(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ComparedTable);
